// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { UpdateBreederBindingAdmin, UpdateBreederBindingAdminSchema } from 'api/gen/UpdateBreederBindingAdmin';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { ValidateBreederBindingAdminBaseObject, ValidateBreederBindingAdminBaseObjectSchema } from 'api/gen/ValidateBreederBindingAdminBaseObject';

const requiredPart = t.interface({
  tag: t.literal('ValidateUpdateBreederBindingAdmin'),
  binding: t.union([UpdateBreederBindingAdminSchema, t.null]),
});

export const ValidateUpdateBreederBindingAdminSchema = excess(t.intersection([ValidateBreederBindingAdminBaseObjectSchema.type, requiredPart]));

export interface ValidateUpdateBreederBindingAdmin extends t.TypeOf<typeof ValidateUpdateBreederBindingAdminSchema> {}
